module.exports = __webpack_public_path__ + "img/pagado_mostrador.aa63182f.png";